import { useMemo } from 'react';

import css from './FavoriteStarToggle.module.scss';

type FavoriteStarToggleProps = {
  isActive: boolean;
  onToggle: () => void;
  ariaLabel?: string;
  disabled?: boolean;
  'data-testid'?: string;
};

const StarIcon = ({ fill }: { fill: string }) => (
  <svg
    aria-hidden="true"
    className={css.icon}
    role="img"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
      fill={fill}
    />
  </svg>
);

export const FavoriteStarToggle = ({
  isActive,
  onToggle,
  ariaLabel = 'Toggle favourite',
  disabled = false,
  'data-testid': dataTestId,
}: FavoriteStarToggleProps) => {
  const fill = useMemo(
    () => (isActive ? 'var(--uui-warning-50)' : 'var(--uui-neutral-60)'),
    [isActive],
  );

  return (
    <button
      aria-label={ariaLabel}
      aria-pressed={isActive}
      className={css.button}
      data-testid={dataTestId}
      disabled={disabled}
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onToggle();
      }}
      onMouseDown={(e) => {
        e.stopPropagation();
      }}>
      <StarIcon fill={fill} />
    </button>
  );
};
